//CR022 Autodesk Vault - CAD Download Basket (MRO_Engineers only)
export const CAD_BASKET_GET_REQUESTED = "CAD_BASKET_GET_REQUESTED";
export const CAD_BASKET_GET_SUCCESS = "CAD_BASKET_GET_SUCCESS";
export const CAD_BASKET_GET_ERROR = "CAD_BASKET_GET_ERROR";
export const CAD_BASKET_ADD_ITEM_REQUESTED = "CAD_BASKET_ADD_ITEM_REQUESTED";
export const CAD_BASKET_REMOVE_ITEM_REQUESTED = "CAD_BASKET_REMOVE_ITEM_REQUESTED";
export const CAD_BASKET_EMPTY_REQUESTED = "CAD_BASKET_EMPTY_REQUESTED";
export const CAD_BASKET_ZIP_REQUESTED = "CAD_BASKET_ZIP_REQUESTED";
export const CAD_BASKET_ZIP_SUCCESS = "CAD_BASKET_ZIP_SUCCESS";
export const CAD_BASKET_ZIP_MESSAGE_RESET = "CAD_BASKET_ZIP_MESSAGE_RESET";
export const CAD_BASKET_RESET = "CAD_BASKET_RESET";

//PDP-transient selection of CAD files to exclude from the ZIP request (chosen before add)
export const CAD_PDP_EXCLUSION_TOGGLE = "CAD_PDP_EXCLUSION_TOGGLE";
export const CAD_PDP_EXCLUSIONS_RESET = "CAD_PDP_EXCLUSIONS_RESET";

//success-message keys (see SUCCESS_MSG_PREFIX, same pattern as ORDER_ACTIONS.ITEM_ADD_SUCCESS)
export const CAD_ITEM_ADD_SUCCESS = "CAD_ITEM_ADD_SUCCESS";
export const CAD_ITEM_REMOVE_SUCCESS = "CAD_ITEM_REMOVE_SUCCESS";
